import React from 'react';
import './Home.css';
const Produccion = ({submenu}) => {
    return (
        <div className="home">
            <div>
                <h2 className = "home-pag-name">Producción</h2>
                <p>Esta es la página principal de Produccion</p>
                <p>{submenu}</p>
            </div>
        </div>
    );
}

export default Produccion;